import { RemoveCenterEnrollmentsInput } from '../../lib/types/models/center/center-enrollment'
import { IdInput, SuccessMessageResponse } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const removeCenterEnrollments = (data: IdInput<RemoveCenterEnrollmentsInput>) => {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.centers.removeCenterEnrollments.url, { id }))
    .post<SuccessMessageResponse, RemoveCenterEnrollmentsInput>(rest)
}
